class SaveRainfallByTimeUseCase {
  constructor(repository) {
    this.repository = repository;
  }
  async execute({ FK_STATION, DATA }) {
    const rainfall = {
      FK_STATION,
      DATA: []
    }

    DATA.map((itemToUpdate) => {
      const [VALUE, TIME] = [
        itemToUpdate.RAINFALL_INPUT,
        itemToUpdate.TIME,
      ];

      rainfall.DATA.push({ VALUE, TIME });
    })

    await this.repository.updateRainfallByTime(rainfall)
  }
}
export {
  SaveRainfallByTimeUseCase
};
